export default __webpack_public_path__ + "static/media/greenLogo.0137d218.png";